// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2ZemM","Icon":"Languages_Icon__I5Ffh","LanguagesSelect":"Languages_LanguagesSelect__9JSD2","minimalist":"Languages_minimalist__3Bmvd"};